(function () {
    'use strict';

    angular
        .module('app')
        .config([
            '$stateProvider',
            '$locationProvider',
            '$urlRouterProvider',
            config
        ]);

    function config($stateProvider, $locationProvider, $urlRouterProvider) {

        $urlRouterProvider.otherwise('/');

        $stateProvider
            .state('home', {
                url: '/',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'home/home.html',
                        controller: 'HomeCtrl as vm'
                    },
                    'notification@home': {
                        templateUrl: 'shared/notificationbar.html',
                        controller: 'NotificationCtrl as vm'
                    }
                },
                data: { requireLogin: true }
            });

        $stateProvider
            .state('admin', {
                url: '/admin',
                abstract: true,
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'admin/admin.html',
                        controller: 'AdminCtrl as vm'
                    }
                },
                data: {
                    requireLogin: true,
                    allowed: 'Administrator'
                }
            });

        $stateProvider
            .state('admin.users', {
                url: '/users',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'admin/admin.html',
                        controller: 'AdminCtrl as vm'
                    },
                    section: {
                        templateUrl: 'admin/users/users.html',
                        controller: 'AdminUsersCtrl as vm'
                    }
                },
                data: { requireLogin: true }
            });

        $stateProvider
            .state('admin.outstanding-approvals', {
                url: '/outstanding-approvals',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'admin/admin.html',
                        controller: 'AdminCtrl as vm'
                    },
                    section: {
                        templateUrl: 'admin/approvals/approvals.html',
                        controller: 'AdminApprovalCtrl as vm'
                    }
                },
                data: { requireLogin: true }
            });

        $stateProvider
            .state('admin.document-management', {
                url: '/document-management',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'admin/admin.html',
                        controller: 'AdminCtrl as vm'
                    },
                    section: {
                        templateUrl: 'admin/documents/documents.html',
                        controller: 'AdminDocumentsCtrl as vm'
                    }
                },
                data: { requireLogin: true }
            });

        $stateProvider
            .state('admin.notifications', {
                url: '/notifications',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'admin/admin.html',
                        controller: 'AdminCtrl as vm'
                    },
                    section: {
                        templateUrl: 'admin/notification/notification.html',
                        controller: 'AdminNotificationCtrl as vm'
                    }
                },
                data: { requireLogin: true }
            });

        $stateProvider
            .state('admin.document-categories', {
                url: '/document-categories',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    footer: {
                        templateUrl: 'shared/footer.html',
                        controller: 'FooterCtrl as vm'
                    },
                    content: {
                        templateUrl: 'admin/admin.html',
                        controller: 'AdminCtrl as vm'
                    },
                    section: {
                        templateUrl: 'admin/settings/settings.html',
                        controller: 'AdminSettingsCtrl as vm'
                    }
                },
                data: { requireLogin: true }
            });

        $stateProvider
            .state('login', {
                url: '/login',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    content: {
                        templateUrl: 'account/account.html'
                    },
                    'form@login': {
                        templateUrl: 'account/login/login.html',
                        controller: 'LoginCtrl as vm'
                    }
                }
            });

        $stateProvider
            .state('forgotpassword', {
                url: '/forgotpassword',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    content: {
                        templateUrl: 'account/account.html'
                    },
                    'form@forgotpassword': {
                        templateUrl: 'account/forgot/forgotpassword.html',
                        controller: 'ForgotPasswordCtrl as vm'
                    }
                }
            });

        $stateProvider
            .state('passwordreset', {
                url: '/passwordreset?email&token',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    content: {
                        templateUrl: 'account/account.html'
                    },
                    'form@passwordreset': {
                        templateUrl: 'account/forgot/passwordreset.html',
                        controller: 'PasswordResetCtrl as vm'
                    }
                },
                resolve: {
                    email: ['$stateParams', function ($stateParams) {
                        return $stateParams.email;
                    }],
                    token: ['$stateParams', function ($stateParams) {
                        return $stateParams.token;
                    }]
                }
            });

        $stateProvider
            .state('register', {
                url: '/register',
                views: {
                    nav: {
                        templateUrl: 'shared/nav.html',
                        controller: 'NavCtrl as vm'
                    },
                    content: {
                        templateUrl: 'account/account.html'
                    },
                    'form@register': {
                        templateUrl: 'account/register/register.html',
                        controller: 'RegisterCtrl as vm'
                    }
                }
            });

        $locationProvider.html5Mode(true);
    };

})();